<div class="row">
  <form (ngSubmit)="sendUploadedFiles(1)" enctype="multipart/form-data">
    <div class="col-md-8">
      <input type="file" #inputFile (change)="onFilesSelected($event)" class="form-control" multiple />
    </div>
    <div class="col-md-12">
      <div class="row mt-2" *ngFor="let file of selectedFiles; let i=index">
        <div class="col-8">
          {{file.name}}
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-danger" (click)="remove(i)"><i class="fa fa-trash"></i></button>
        </div>
      </div>
    </div>

    <!-- <div class="col-md-4">
      <button type="submit" class="btn btn-primary">Upload</button>
    </div> -->
  </form>
</div>